// Modern vector derivative of the supplied manual mark, not an official master.
// One asset serves the header and favicon. Decorative: product text names the app.
export function BrandMark() {
  return <svg className="brand-mark" viewBox="0 0 256 240" aria-hidden="true" focusable="false">
    <use href={`${import.meta.env.BASE_URL}branding/fairlight-mark.svg#fairlight-mark`} />
  </svg>;
}
